import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import AppHeader from '@/components/Header.vue'
import {
  getFaultWarningOrderBySn,
  getLastFlyLog,
  getRepairDeviceDetail,
} from '@/apis/malfunction-repair'
import type { GetDeviceFlyLogsItem } from '@/types/malfunction-repair'
import { commonErrorHandle } from '@/utils/error-handle'
import { MalfunctionRepairSelectedDevicesStorage } from '@/storage/malfunction-repair'
import { clearToast, showToastLoading } from '@/utils/tools'

// 中转页面，判断当前的页面需要跳转到哪个页面
// 若没有sn, 则跳转提单列表页
// 有sn默认则判断是否有type类型, type值是warning时，需要处理故障处理的业务逻辑
// type没有设置时，则直接进入提单页面, 20251223年，暂未有接口直接支持查询设备信息, 当前默认都跳转设备列表页


export default /*#__PURE__*/_defineComponent({
  __name: 'triage-page',
  setup(__props) {

const $route = useRoute()
const $router = useRouter()
const sn = $route.query.sn as string
const type = $route.query.type as string

async function fetchAndStoreDevice() {
  try {
    const deviceDetail = await getRepairDeviceDetail(sn)
    // 存储设备信息，以便后续页面使用
    MalfunctionRepairSelectedDevicesStorage.set([deviceDetail])
  } catch (error) {
    // 如果获取设备详情失败，继续跳转，但可能影响后续页面
    console.error('Failed to fetch device detail:', error)
  }
}

async function jumpToFaultForm() {
  await fetchAndStoreDevice()
  $router.replace({
    name: 'malfunction-repair-fault-form',
    query: { sn },
  })
  clearToast()
}

async function jumpToNetworkList(lastFlyLog: GetDeviceFlyLogsItem, warningGuid: string) {
  await fetchAndStoreDevice()
  $router.replace({
    name: 'malfunction-repair-network-list',
    query: {
      sn,
      guid: lastFlyLog.guid,
      is_boom: lastFlyLog.isBoom.toString(),
      warningGuid,
    },
  })
  clearToast()
}

async function handleWarning() {
  showToastLoading()
  try {
    // 1. 获取故障工单信息
    const warningOrder = await getFaultWarningOrderBySn(sn)
    // 2. 判断是否可一键提单
    if (!warningOrder?.submit) {
      // 不可一键提单，直接跳转到故障表单页面
      await jumpToFaultForm()
      return
    }
    // 3. 可一键提单，获取最后一个飞行日志（可能失败）
    let lastFlyLog = null
    try {
      lastFlyLog = await getLastFlyLog(sn)
    } catch (error) {
      console.error('Failed to fetch last fly log:', error)
      // 如果获取飞行日志失败，默认跳转到故障表单页面
      await jumpToFaultForm()
      return
    }
    // 4. 判断是否炸机
    if (!lastFlyLog || lastFlyLog.isBoom) {
      // 炸机，获取设备详情并存储，然后跳转到提单页面
      await jumpToFaultForm()
    } else {
      // 非炸机，获取设备详情并存储，携带序列号、飞行日志guid和is_boom跳转到故障报修下网点选择页面
      await jumpToNetworkList(lastFlyLog, warningOrder.guid)
    }
  } catch (error) {
    commonErrorHandle(error)
    // 出错时跳转到设备列表页
    // $router.replace({
    //   name: 'malfunction-repair-devices',
    // })
  }
}

onMounted(() => {
  if (!sn) {
    $router.replace({
      name: 'malfunction-repair-devices',
    })
  } else {
    if (type === 'warning') {
      // 处理故障预警的业务逻辑
      handleWarning()
    } else {
      // 接口支持单个序列号查询设备信息时，直接去到提单的页面
      // 暂时不支持的情况下, 默认也是跳转到设备列表页
      $router.replace({
        name: 'malfunction-repair-devices',
      })
    }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppHeader, { title: "故障报修" }))
}
}

})